import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import {useParams} from'react-router';
import {ROUTES} from '../../shared/constants'
import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'
import Layout from '../../components/Layout'
import HeaderTabLayout from '../../components/HeaderTabLayout'
export default function AddChannelTypeMaster({ channelTypeMaster: channelTypeMasterData }) {
  // const {name} = channelTypeMasterData
  const queryClient = useQueryClient()
  const history = useHistory()
  const [channelTypeMaster, setchannelTypeMaster] = useState({
    name: channelTypeMasterData?.name ? channelTypeMasterData.name : ''
  })

  const data = [{ label: 'Channel Type Master Name', value: channelTypeMaster.name, name: 'name' }]

  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    setLoading(true)
    if (channelTypeMasterData || id.channelTypeMasterId!== undefined) {
      console.log(channelTypeMasterData, channelTypeMaster);
      updateDocumentByID('/update/channel/type', channelTypeMasterData._id, {...channelTypeMaster})
      queryClient.invalidateQueries('channel-type-master')
      setLoading(false)
    } else {
      
      createDocument('/create/channel/type', channelTypeMaster)
      queryClient.invalidateQueries('channel-type-master')
      setLoading(false)
    }

    history.push('/channel-type-master')
  }
  const id = useParams();

  return (
    <Layout heading={`Channel Types`} heading2={` ${id.channelTypeMasterId !== undefined? 'Edit' : 'Add'}`} url1={ROUTES.CHANNEL_TYPE_MASTER} none>
      <HeaderTabLayout
        heading={ `${id.channelTypeMasterId!==undefined ? 'Edit' : 'Add'}  Channel Type `}
        content={
          <CustomAddForm
            heading="Channel Type Master"
            redirect={'CHANNEL_TYPE_MASTER'}
            loading={loading}
            state={channelTypeMaster}
            setState={setchannelTypeMaster}
            handleClick={handleClick}
            data={data}
        />}
        state={channelTypeMaster}
        setState={setchannelTypeMaster}
        addContent={handleClick}
        text={`${id.channelTypeMasterId!==undefined ? 'Update' : 'Add'}`}
        redirect={ROUTES.CHANNEL_TYPE_MASTER}
        loading={loading}
      />
          
          
      
      
      {/* <button onClick={Channel Typesubmit}>Submit the Channel Types</button> */}
    </Layout>
    
  )
}
